import React from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBAspectProps } from './props';
import { Styles } from './styles';

/*
    This view keeps a consistent aspect ratio based on its width.
    Here's the logic beind it:
    https://www.w3schools.com/howto/howto_css_aspect_ratio.asp

    Why do we need to wrap it in 3 views?
    1. to apply the view's style (eg something that can affect width)
    2. create a view with full width and padding (CSS hack to keep aspect ratio)
    3. absolutely positioned child inside CSS aspect ratio hack

*/
export function MBAspect({ ratio, children, center, ...otherProps }: MBAspectProps) {
  return (
    <MBView {...otherProps} center={center}>
      <MBView style={[Styles.container, { paddingTop: `${100 / ratio}%` }]}>
        <View absolute center={center}>
          {children}
        </View>
      </MBView>
    </MBView>
  );
}
